import { useState } from "react";
import { translate } from "../../../utils/Common";

const DateIncident = ({ register, errors, sizeInput }) => {

    const [dateFrom, setDateFrom] = useState(null);

    const handleDateFromChange = (event) => {
      setDateFrom(event.target.value);
    };

    
  return (
    <div className="flex" style={{gap:8}}>
      <div>
        <label htmlFor="startDate" className="flex justify-center font-semibold">{translate("dashboard.accounting.from")}</label>
        <input
          className={`${
            sizeInput ?? "h-9 text-sm"
          } h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed font-small`}
          name="startDate"
          ref={register({ required: translate("global.select") })}
          type="date"
          onChange={handleDateFromChange}
        />
        {errors.dateFrom && (
          <span className="text-destructive">{errors.dateFrom.message}</span>
        )}
      </div>

      <div>
        <label htmlFor="endDate" className="flex justify-center font-semibold">{translate("dashboard.accounting.to")}</label>
        <input
          className={`${
            sizeInput ?? "h-9 text-sm"
          } h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed font-small`}
          name="endDate"
          ref={register({ required: translate("global.select") })}
          type="date"
          min={dateFrom}
          disabled={!dateFrom} 
        />
        {errors.dateTo && (
          <span className="text-destructive">{errors.dateTo.message}</span>
        )}
      </div>
    </div>
  );
};

export default DateIncident;
